module.exports = __webpack_public_path__ + "img/t3-intro-text.097a2bbd.png";